import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, Alert, Divider } from 'antd';
import { LockOutlined, UserOutlined, SafetyCertificateOutlined } from '@ant-design/icons';
import { login } from '../api/client';

const { Title, Text } = Typography;

export default function Login({ onSuccess, onSSOClick }) {
  const [loading, setLoading] = useState(false);
  const [ssoLoading, setSSOLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showAdminForm, setShowAdminForm] = useState(!onSSOClick);

  const handleSubmit = async (values) => {
    setLoading(true);
    setError(null);
    try {
      await login(values.username, values.password);
      onSuccess();
    } catch (err) {
      const msg =
        !err.response
          ? 'Cannot reach the server. Please connect to the Veeva VPN and try again.'
          : err.response.status === 401
          ? 'Invalid username or password.'
          : err.response.data?.error || 'Login failed. Please try again.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  const handleSSO = async () => {
    setSSOLoading(true);
    try {
      await onSSOClick();
    } catch {
      setSSOLoading(false);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: '#f0f2f5',
      }}
    >
      <Card style={{ width: 400, boxShadow: '0 4px 24px rgba(0,0,0,0.10)' }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <Title level={3} style={{ marginBottom: 4 }}>
            Infrastructure Management System
          </Title>
          <Text type="secondary">Sign in to continue</Text>
        </div>

        {/* SSO button — shown when Okta is configured */}
        {onSSOClick && (
          <>
            <Button
              size="large"
              block
              icon={<SafetyCertificateOutlined />}
              loading={ssoLoading}
              onClick={handleSSO}
              style={{
                background: '#E8741A',
                borderColor: '#E8741A',
                color: '#fff',
                fontWeight: 600,
                marginBottom: 4,
              }}
            >
              Sign in with SSO
            </Button>
            <Text type="secondary" style={{ display: 'block', textAlign: 'center', fontSize: 12, marginBottom: 16 }}>
              Use your Veeva Okta account
            </Text>

            <Divider style={{ margin: '12px 0' }}>
              <Text type="secondary" style={{ fontSize: 12 }}>Admin access</Text>
            </Divider>

            {!showAdminForm ? (
              <Button
                type="link"
                block
                size="small"
                onClick={() => setShowAdminForm(true)}
                style={{ color: '#8c8c8c', fontSize: 12 }}
              >
                Sign in with admin credentials
              </Button>
            ) : null}
          </>
        )}

        {/* Admin / break-glass form */}
        {showAdminForm && (
          <>
            {error && (
              <Alert
                message={error}
                type="error"
                showIcon
                style={{ marginBottom: 16 }}
              />
            )}

            <Form layout="vertical" onFinish={handleSubmit} autoComplete="off">
              <Form.Item
                name="username"
                rules={[{ required: true, message: 'Please enter your username' }]}
              >
                <Input
                  prefix={<UserOutlined />}
                  placeholder="Username"
                  size="large"
                  autoFocus={!onSSOClick}
                />
              </Form.Item>

              <Form.Item
                name="password"
                rules={[{ required: true, message: 'Please enter your password' }]}
              >
                <Input.Password
                  prefix={<LockOutlined />}
                  placeholder="Password"
                  size="large"
                />
              </Form.Item>

              <Form.Item style={{ marginBottom: 0 }}>
                <Button
                  type={onSSOClick ? 'default' : 'primary'}
                  htmlType="submit"
                  size="large"
                  loading={loading}
                  block
                >
                  Sign In
                </Button>
              </Form.Item>
            </Form>
          </>
        )}
      </Card>
    </div>
  );
}
